module.exports = __webpack_public_path__ + "static/media/print-icon.b0fb3e6c.svg";